import { render, staticRenderFns } from "./procurementContractDetail.vue?vue&type=template&id=02d8a3bd&scoped=true"
import script from "./procurementContractDetail.vue?vue&type=script&lang=js"
export * from "./procurementContractDetail.vue?vue&type=script&lang=js"
import style0 from "./procurementContractDetail.vue?vue&type=style&index=0&id=02d8a3bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d8a3bd",
  null
  
)

export default component.exports